import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft,  } from "react-icons/fa";
import { motion } from "framer-motion";

const Orderview = () => {
  const navigate = useNavigate();

  return (
    <div className="relative bg-white flex justify-center top-20">
      <div className="w-full max-w-md min-h-screen bg-white pt-4">

        {/* Page Content */}
        <div className="px-4 pt-4 pb-5">
          {/* Current Order Status */}
          <div className="mb-4">
            <div className="flex items-center gap-2 justify-between">
              <h2 className="text-[19px] font-semibold text-gray-900">
                View Order
              </h2>
              <motion.span
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                     onClick={() => navigate("/account/order-history")}
                    className=" text-xs text-green-700 font-bold cursor-pointer px-3 py-1.5 rounded-[5px] transition-all bg-green-50/80 border border-green-200 flex items-center gap-1.5"
                  >
                   <FaArrowLeft className="text-[10px]" /> Back 
                  </motion.span>
            </div>

            <p className="text-[14px] text-gray-500 mt-1">
              Order #243787211194910
            </p>
          </div>

          {/* Order Summary */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm mb-3 px-3 py-3.5">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 rounded-full bg-green-50 flex items-center justify-center">
                <i className="las la-file-alt text-green-700 text-xl"></i>
              </div>

              <h3 className="text-[13px] font-semibold text-gray-800">
                Order Summary
              </h3>
            </div>

            <div className="grid grid-cols-3">
              {/* Items */}
              <div className="text-center border-r border-gray-200">
                <div className="flex justify-center">
                 <i className="las la-shopping-bag text-green-700 text-xl"></i>
                </div>
                <p className="text-[14px] text-gray-500">Items</p>
                <p className="text-[16px] font-semibold text-gray-900 mt-1">
                  4
                </p>
              </div>
              {/* Total */}
              <div className="text-center border-r border-gray-200">
                <div className="flex justify-center">
                  <i className="las la-rupee-sign text-green-700 text-xl"></i>
                </div>

                <p className="text-[14px] text-gray-500">Total</p>

                <p className="text-[16px] font-semibold text-green-700 mt-1">
                  ₹624.00
                </p>
              </div>

              {/* Placed On */}
              <div className="text-center">
                <div className="flex justify-center">
                  <i className="las la-stopwatch text-green-700 text-2xl"></i>
                </div>
                <p className="text-[14px] text-gray-500">Placed on</p>
                <p className="text-[10px] font-semibold text-gray-800 mt-1 whitespace-nowrap">
                  23 Jul 2026, 08:36 PM
                </p>
              </div>
            </div>
          </div>

          {/* Bill Details */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-sm overflow-hidden">
            {/* Bill Header */}
            <div className="flex items-center justify-between px-3 py-3">
              <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded-full bg-green-50 flex items-center justify-center">
                 <i className="las la-file-alt text-green-700 text-2xl"></i>
                </div>

                <h3 className="text-[13px] font-semibold text-gray-800">
                  Bill Details
                </h3>
              </div>
            </div>

            {/* Products */}
            <div className="px-3">
              {/* Product 1 */}
              <div className="flex items-center justify-between py-2.5">
                <div className="flex items-center gap-2">
                  <span className="w-3.5 h-3.5 rounded-[3px] border border-green-600 flex items-center justify-center">
                    <span className="w-2 h-2 rounded-full bg-green-600"></span>
                  </span>

                  <span className="text-[11px] text-gray-800">
                    SCHEZWAN MUSHROOM NOODLES × 1
                  </span>
                </div>

                <span className="text-[11px] text-gray-800 font-medium">
                  ₹202.50
                </span>
              </div>

              {/* Product 2 */}
              <div className="flex items-center justify-between py-2.5">
                <div className="flex items-center gap-2">
                  <span className="w-3.5 h-3.5 rounded-[3px] border border-green-600 flex items-center justify-center">
                    <span className="w-2 h-2 rounded-full bg-green-600"></span>
                  </span>

                  <span className="text-[11px] text-gray-800">
                    Plain Dosai × 1
                  </span>
                </div>

                <span className="text-[11px] text-gray-800 font-medium">
                  ₹101.25
                </span>
              </div>

              {/* Product 3 */}
              <div className="flex items-center justify-between py-2.5">
                <div className="flex items-center gap-2">
                  <span className="w-3.5 h-3.5 rounded-[3px] border border-green-600 flex items-center justify-center">
                    <span className="w-2 h-2 rounded-full bg-green-600"></span>
                  </span>

                  <span className="text-[11px] text-gray-800">
                    GHEE RAVA DOSAI × 1
                  </span>
                </div>

                <span className="text-[11px] text-gray-800 font-medium">
                  ₹135.00
                </span>
              </div>

              {/* Product 4 */}
              <div className="flex items-center justify-between py-2.5">
                <div className="flex items-center gap-2">
                  <span className="w-3.5 h-3.5 rounded-[3px] border border-green-600 flex items-center justify-center">
                    <span className="w-2 h-2 rounded-full bg-green-600"></span>
                  </span>

                  <span className="text-[11px] text-gray-800">
                    Idly – 4 Pcs × 1
                  </span>
                </div>

                <span className="text-[11px] text-gray-800 font-medium">
                  ₹94.50
                </span>
              </div>

              {/* Divider */}
              <div className="border-t border-gray-100 mt-1"></div>

              {/* Item Total */}
              <div className="flex items-center justify-between py-2.5">
                <div className="flex items-center gap-2">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#00843D"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="5" y="3" width="14" height="18" rx="2" />
                    <path d="M8 9h8M8 13h8M8 17h5" />
                  </svg>

                  <span className="text-[11px] text-gray-700">Item Total</span>
                </div>

                <span className="text-[11px] text-gray-800">₹533.25</span>
              </div>

              {/* Discount */}
              <div className="flex items-center justify-between py-2">
                <div className="flex items-center gap-2">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#00843D"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 12l-8 8H5a1 1 0 0 1-1-1v-7l8-8h7a1 1 0 0 1 1 1v7z" />
                    <circle cx="8" cy="9" r="1" />
                  </svg>

                  <span className="text-[11px] text-green-700">
                    Discount Applied
                  </span>
                </div>

                <span className="text-[11px] text-green-700 font-medium">
                  –₹5.50
                </span>
              </div>

              {/* Taxes */}
              <div className="flex items-center justify-between py-2">
                <div className="flex items-center gap-2">
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#00843D"
                    strokeWidth="1.7"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="5" y="4" width="14" height="16" rx="2" />
                    <path d="M8 8h8M8 12h5M8 16h7" />
                  </svg>

                  <span className="text-[11px] text-gray-700">Taxes</span>
                </div>

                <span className="text-[11px] text-gray-800">₹33.19</span>
              </div>
            </div>

            {/* Total Bill */}
            <div className="border-t border-gray-100 px-3 py-3 flex items-center justify-between">
              <span className="text-[13px] font-semibold text-gray-900">
                Total Bill Amount
              </span>

              <span className="text-[18px] font-bold text-green-700">
                ₹624.00
              </span>
            </div>
          </div>

          {/* Reorder */}
          <button className="w-full h-[42px] mt-3 rounded-lg bg-[#00713b] text-white font-semibold text-xs flex items-center justify-center gap-2 shadow-sm">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M20 11a8 8 0 1 0 1 4" />
              <path d="M20 4v7h-7" />
            </svg>
            REORDER
          </button>
        </div>
      </div>
    </div>
  );
};

export default Orderview;
